import type { ILangData } from "@/queries/useTranslations";
import { type IContentType, type ILanguage, LANGUAGES } from "@/types";

const COPY_ROW_SEPARATOR = "\n\n\n";

export function buildCopyRowText(
    contentType: IContentType,
    id: string,
    context: string,
    texts: ILangData,
    langs: ILanguage[],
): string {
    const selectedLanguages = LANGUAGES.filter((lang) => langs.includes(lang));
    const metadata = [`<id>${contentType}.${id}</id>`, context && `<context>${context}</context>`]
        .filter(Boolean)
        .join("\n");
    return [metadata, ...selectedLanguages.map((lang) => texts[lang])].join(COPY_ROW_SEPARATOR);
}
